import * as React from 'react';
import { AnchorHTMLAttributes } from 'react';
import { Link } from 'react-router-dom';

interface OptionalLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
    href?: string;
    to?: string;
}

export class OptionalLink extends React.Component<OptionalLinkProps> {
    render() {
        const { href, to, ...props } = this.props;
        if (href) {
            return <a href={href} {...props} />;
        }

        if (to) {
            return <Link to={to} {...props} />;
        }

        return props.children;
    }
}
